export const formatValue = value =>
  Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 3,
    notation: 'compact',
  }).format(value);

export const formatThousands = value =>
  Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3,
    notation: 'compact',
  }).format(value);

export const getCssVariable = variable => {
  const fallbackColors = {
    '--color-gray-100': '#f3f4f6',
    '--color-gray-200': '#e5e7eb',
    '--color-gray-400': '#9ca3af',
    '--color-gray-500': '#6b7280',
    '--color-gray-600': '#4b5563',
    '--color-gray-700': '#374151',
    '--color-gray-800': '#1f2937',
    '--color-gray-900': '#111827',
    '--color-white': '#ffffff',
    '--color-black': '#000000',
  };

  return fallbackColors[variable] || '#000000';
};

export const adjustColorOpacity = (color, opacity) => {
  if (!color) return `rgba(0, 0, 0, ${opacity})`;

  if (color.startsWith('rgba')) {
    return color.replace(/[\d.]+\)$/g, `${opacity})`);
  }

  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  return `rgba(132, 112, 255, ${opacity})`;
};

export const oklchToRGBA = oklchColor => {
  return 'rgba(132, 112, 255, 1)';
};

export const dateToISO = date => {
  if (!date) return '';

  if (date instanceof Date) {
    return date.toISOString();
  }

  return new Date(date).toISOString();
};

export const getFormattedDate = date => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString('en-US', options);
};

export const formatPhoneNumber = phoneNumberString => {
  if (!phoneNumberString) return 'N/A';
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phoneNumberString;
};

export const formatDateToUtcString = dateString => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Use local timezone
  };
  return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const formatUtcToLocal = utcDateString => {
  if (!utcDateString) return '';

  const date = new Date(utcDateString);

  // Invalid date check
  if (isNaN(date.getTime())) return '';

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    // Do NOT specify timeZone — it defaults to the user's local timezone
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
};
